module.exports = __webpack_public_path__ + "img/adventure.ca2e8bf6.svg";